<template>
<div class="search-count"
  tabindex="0"
  @keydown.left.prevent="onDecrease"
  @keydown.right.prevent="onIncrease"
  @keydown.up.prevent="tabHandler"
  @keydown.down.prevent="tabHandler"
  @keydown.space.prevent="">
  <div class="decrease" :disabled="this.value === this.config.minimum" @click="onDecrease">
    <slot name="decrease"><i class="owl-status-remove"></i></slot>
  </div>
  <div class="value">
    <div>
      <span class="text-xl font-bold text-blue">{{ value }}</span>
      <slot><span>間客房</span></slot>
    </div>
    <slot name="extend"></slot>
  </div>
  <div class="increase" :disabled="this.value === this.config.maximum" @click="onIncrease">
    <slot name="increase"><i class="owl-status-add"></i></slot>
  </div>
</div>
</template>

<script>
export default {
  name: '',
  props: {
    value: {
      type: Number,
      required: true
    },
    options: {
      type: Object
    }
  },
  data () {
    return {
      config: {
        minimum: 0,
        maximum: 10
      }
    }
  },
  methods: {
    initialize: function () {
      this.config = {
        ...this.config,
        ...this.options
      }
      if (this.config?.default) {
        this.$emit('input', this.config.default)
      }
    },
    onDecrease: function () {
      if (this.value === this.config.minimum) return
      this.$emit('input', this.value - 1)
      if (this.$route.name === 'Home') {
        window.dataLayer.push({
          event: `index_searchbar_people_${this.options.type}_minus`
        })
      } else {
        window.dataLayer.push({
          event: `list_searchbar_people_${this.options.type}_minus`
        })
      }
    },
    onIncrease: function () {
      if (this.value === this.config.maximum) return
      this.$emit('input', this.value + 1)
      if (this.$route.name === 'Home') {
        window.dataLayer.push({
          event: `index_searchbar_people_${this.options.type}_add`
        })
      } else {
        window.dataLayer.push({
          event: `list_searchbar_people_${this.options.type}_add`
        })
      }
    },
    tabHandler: function (e) {
      if (e.key === 'ArrowUp') {
        const pre = e.currentTarget.previousElementSibling
        if (pre) {
          pre.focus()
        }
      }
      if (e.key === 'ArrowDown') {
        const next = e.currentTarget.nextElementSibling
        if (next) {
          next.focus()
        }
      }
    }
  },
  created () {
    this.initialize()
  },
  watch: {
    value: {
      handler: function (val, oldVal) {
        this.$emit('change', val)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.search-count
  @apply flex items-center justify-between
  .decrease, .increase
    @apply p-4 leading-sm inline-block flex items-center justify-center
    @apply border border-grey-light
    @apply cursor-pointer
    @apply rounded-full
    @apply text-grey-darker text-sm
    &:hover
      @apply bg-grey-lightest
    &[disabled]
      @apply cursor-default bg-white opacity-50 #{!important}
</style>
